export default __webpack_public_path__ + "static/media/ok.788e5f9d.svg";